import { Tool } from 'feather-icons-react/build/IconComponents'
import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../core/img/imagewithbasebath'
import { Switch } from 'antd'
import ToolsHead from '../../components/toolsHead'

const PaymentGateway = () => {
    return (
        <div>
            <div className="page-wrapper">
                <div className="content settings-content">
                    <div className="page-header settings-pg-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Configuración de Métodos de Pago</h4>
                                <h6>Puedes visualizar los métodos de pago integrados al sistema.</h6>
                            </div>
                        </div>
                        <ToolsHead showExportData={false} showPdf={false} showPrint={false} showExcel={false} onReload={() => { }} />
                    </div>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="settings-wrapper d-flex">
                                <div className="settings-page-wrap">
                                    <div className="row social-authent-settings">
                                        <div className="col-xxl-4 col-xl-6 col-lg-12 col-md-6 d-flex">
                                            <div className="connected-app-card d-flex w-100">
                                                <ul className="w-100">
                                                    <li className="flex-column align-items-start">
                                                        <div className="d-flex align-items-center justify-content-between w-100 mb-2">
                                                            <div className="security-type d-flex align-items-center">
                                                                <span>
                                                                    <ImageWithBasePath
                                                                        src="assets/img/icons/payment-icon-10.svg"
                                                                        alt="Payment"
                                                                    />
                                                                </span>
                                                            </div>
                                                            <div className="connect-btn">
                                                                <Link to="#">Conectado</Link>
                                                            </div>
                                                        </div>
                                                        <p>
                                                            Point de Mercado Pago es un dispositivo lector de tarjetas que permite cobrar a sus clientes con tarjeta de crédito, débito o a través de pagos digitales.
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <div className="integration-btn">
                                                            <a href="https://www.mercadopago.com.mx/developers/panel/app" target="_blank" rel="noreferrer">
                                                                <Tool className="me-2" />
                                                                Ver integración
                                                            </a>
                                                        </div>
                                                        <div className="status-toggle modal-status d-flex justify-content-between align-items-center ms-2">
                                                            <Switch
                                                                checked
                                                                disabled
                                                            />
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentGateway
